import React, { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminUpload = () => {
  const [llcFile, setLlcFile] = useState(null);
  const [referralFile, setReferralFile] = useState(null);
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');

  const handleAuth = (e) => {
    e.preventDefault();
    // Simple password check (change "admin123" to your preferred password)
    if (password === 'Ability2025!') {
      setIsAuthenticated(true);
      setMessage('');
    } else {
      setMessage('Incorrect password');
    }
  };

  const handleLLCUpload = async (e) => {
    e.preventDefault();
    if (!llcFile) return;

    setUploading(true);
    setMessage('');

    const formData = new FormData();
    formData.append('file', llcFile);
    formData.append('resource_type', 'llc-guide');

    try {
      await axios.post(`${API}/upload-resource`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      setMessage('LLC Guide uploaded successfully!');
      setLlcFile(null);
    } catch (error) {
      setMessage('Upload failed: ' + (error.response?.data?.detail || error.message));
    } finally {
      setUploading(false);
    }
  };

  const handleReferralUpload = async (e) => {
    e.preventDefault();
    if (!referralFile) return;

    setUploading(true);
    setMessage('');

    const formData = new FormData();
    formData.append('file', referralFile);
    formData.append('resource_type', 'referral-list');

    try {
      await axios.post(`${API}/upload-resource`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      setMessage('Referral List uploaded successfully!');
      setReferralFile(null);
    } catch (error) {
      setMessage('Upload failed: ' + (error.response?.data?.detail || error.message));
    } finally {
      setUploading(false);
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-black text-white flex items-center justify-center p-4">
        <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl shadow-2xl p-8 max-w-md w-full border-2 border-blue-500">
          <h1 className="text-3xl font-bold mb-6 text-center">Admin Access</h1>
          <form onSubmit={handleAuth}>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 bg-gray-700 border-2 border-gray-600 rounded-lg text-white"
                placeholder="Enter admin password"
                required
              />
            </div>
            {message && (
              <div className="mb-4 text-red-400 text-sm">{message}</div>
            )}
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-3 rounded-lg font-bold hover:bg-blue-700 transition"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-black text-white p-4">
      <div className="max-w-4xl mx-auto py-12">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-4xl font-bold">Resource Upload Center</h1>
          <button
            onClick={() => setIsAuthenticated(false)}
            className="text-gray-400 hover:text-white transition"
          >
            Logout
          </button>
        </div>

        {message && (
          <div className={`mb-6 p-4 rounded-lg ${message.includes('success') ? 'bg-green-900/30 border-2 border-green-500 text-green-300' : 'bg-red-900/30 border-2 border-red-500 text-red-300'}`}>
            {message}
          </div>
        )}

        {/* LLC Guide Upload */}
        <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl shadow-2xl p-8 mb-8 border-2 border-green-500">
          <h2 className="text-2xl font-bold mb-4">Start Your Home-Care LLC Guide ($24.99)</h2>
          <form onSubmit={handleLLCUpload}>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">Upload PDF File</label>
              <input
                type="file"
                accept=".pdf"
                onChange={(e) => setLlcFile(e.target.files[0])}
                className="w-full px-4 py-3 bg-gray-700 border-2 border-gray-600 rounded-lg text-white file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-blue-600 file:text-white hover:file:bg-blue-700"
                required
              />
            </div>
            {llcFile && (
              <p className="text-sm text-gray-400 mb-4">Selected: {llcFile.name}</p>
            )}
            <button
              type="submit"
              disabled={!llcFile || uploading}
              className="w-full bg-green-600 text-white py-3 rounded-lg font-bold hover:bg-green-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {uploading ? 'Uploading...' : 'Upload LLC Guide'}
            </button>
          </form>
        </div>

        {/* Referral List Upload */}
        <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl shadow-2xl p-8 border-2 border-blue-500">
          <h2 className="text-2xl font-bold mb-4">Referral Partner Database ($149.99)</h2>
          <form onSubmit={handleReferralUpload}>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">Upload PDF File</label>
              <input
                type="file"
                accept=".pdf"
                onChange={(e) => setReferralFile(e.target.files[0])}
                className="w-full px-4 py-3 bg-gray-700 border-2 border-gray-600 rounded-lg text-white file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-blue-600 file:text-white hover:file:bg-blue-700"
                required
              />
            </div>
            {referralFile && (
              <p className="text-sm text-gray-400 mb-4">Selected: {referralFile.name}</p>
            )}
            <button
              type="submit"
              disabled={!referralFile || uploading}
              className="w-full bg-blue-600 text-white py-3 rounded-lg font-bold hover:bg-blue-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {uploading ? 'Uploading...' : 'Upload Referral List'}
            </button>
          </form>
        </div>

        <div className="mt-8 bg-blue-900/30 border border-blue-500 rounded-xl p-6">
          <h3 className="font-bold text-lg mb-2">Instructions:</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-300">
            <li>Upload PDF files for each resource</li>
            <li>Files will be stored securely and made available for purchase</li>
            <li>You can re-upload to update the files anytime</li>
            <li>Customers will receive download links after payment</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AdminUpload;
